import { CountUp } from 'countup.js';
import whenDomReady from 'when-dom-ready';
function initialise() {
    const counts = document.querySelectorAll('.js-count-up');
    if (!counts) {
        return;
    }
    const defaults = {
        useEasing: true,
        useGrouping: true,
        separator: ',',
    };
    counts.forEach((item) => {
        const countItem = item;
        const options = {
            ...defaults,
            decimalPlaces: countItem.getAttribute('data-count-decimal')
                ? parseInt(countItem.getAttribute('data-count-decimal'), 10)
                : undefined,
        };
        const prefix = countItem.getAttribute('data-count-prefix');
        const suffix = countItem.getAttribute('data-count-suffix');
        if (prefix !== null) {
            options.prefix = prefix;
        }
        if (suffix !== null) {
            options.suffix = suffix;
        }
        const count = new CountUp(countItem.getAttribute('id') || '', parseFloat(countItem.getAttribute('data-count-end') || ''), options);
        const oOptions = {
            root: null,
            rootMargin: '0px',
            threshold: 1,
        };
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.intersectionRatio > 0) {
                    count.start();
                }
            });
        }, oOptions);
        observer.observe(countItem);
    });
}
whenDomReady().then(initialise);
